import styled from "styled-components"
import { BranchKind, THEN } from "../../branchKind"

export const BranchLabel = styled.div<{ $variant: BranchKind }>`
  position: absolute;
  pointer-events: none;
  padding: 0.25rem 0.9rem;
  border-radius: 1rem;
  font-size: 0.95rem;
  line-height: 1;
  ${(p) => p.theme.bold};
  text-transform: uppercase;
  letter-spacing: 0.08rem;
  color: ${(p) => p.theme.colors.white};
  background: ${(p) => (p.$variant === THEN ? "#10b981" : "#ef4444")};
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.12);
  white-space: nowrap;
`

export const AddButton = styled.button`
  position: absolute;
  pointer-events: all;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  background: ${(p) => p.theme.colors.white};
  color: ${(p) => p.theme.colors.greyDarker};
  font-size: 1.6rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.08);
  transition: all 0.15s ease;
  padding: 0;

  &:hover {
    background: ${(p) => p.theme.colors.turquoiseDark};
    border-color: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.white};
    box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15);
  }
`
